import Vue from './vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index'
import '@/assets/css/element-variables.scss'

/*不建议修改main.js*/
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');


// 配置不同项目的favicon图标,和网站标题
const favPath = process.env.VUE_APP_FAV_PATH
const title = process.env.VUE_APP_WEBSITE_TITLE
let link = document.querySelector(".iconLink"); //先获取link标签对象
let titleEle = document.querySelector('.global-title')
link.href = favPath; //设置href链接
titleEle.innerHTML = title //设置网站标题